import { render, staticRenderFns } from "./PruebaCa.vue?vue&type=template&id=1a2723f7"
import script from "./PruebaCa.vue?vue&type=script&lang=js"
export * from "./PruebaCa.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports